import {useParams} from "react-router-dom";

import {useEffect} from "react";
import {IPackage} from "@evennt-tech/api-v2-core";
import {useLocalisedLanguageCode} from "hooks/translation";
import {usePackages} from "store/package/package.store";
import {shallow} from "zustand/shallow";

type UseCurrentShowBuildTypesResult = [IPackage[], boolean?];

type Args = {
  localised?: boolean;
};

export default ({
  localised = false,
}: Args = {}): UseCurrentShowBuildTypesResult => {
  const {showId} = useParams<{showId?: string}>();
  const languageCode = useLocalisedLanguageCode(localised);

  const {
    fetch: fetchPackagesInShow,
    autoCatch: autoCatchPackages,
  } = usePackages();

  const packages = usePackages(
    (state) => state.getByShowId(showId as string),
    shallow
  );

  const isLoading = usePackages((state) => state.isLoading, shallow);

  useEffect(() => {
    if (!showId) {
      return;
    }

    const load = async () => {
      await autoCatchPackages(showId);
      await fetchPackagesInShow(showId, false, languageCode);
    };

    load();
  }, [showId, languageCode]);

  return [packages, isLoading];
};
